(function () {
  function qs(root, sel) {
    return root.querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function initSheet(section) {
    var sheet = qs(section, '[data-nsp-feel-sheet]');
    if (!sheet) return;
    var openBtn = qs(section, '[data-nsp-feel-open]');
    var closers = qsa(sheet, '[data-nsp-feel-close]');

    function open() {
      sheet.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = qs(sheet, '.nsp-feel-sheet__close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      sheet.hidden = true;
      document.documentElement.style.overflow = '';
      if (openBtn) openBtn.focus();
    }

    if (openBtn) openBtn.addEventListener('click', open);
    closers.forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });
  }

  function boot() {
    qsa(document, '.nsp-shirt-style').forEach(initSheet);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) {
      var section = e.target.querySelector('.nsp-shirt-style') || e.target;
      if (section.classList && section.classList.contains('nsp-shirt-style')) initSheet(section);
    }
  });
})();